var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHustlersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 231 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.082 229.829C178.557 229.829 230.015 178.417 230.015 114.997C230.015 51.5766 178.557 0.165039 115.082 0.165039C51.606 0.165039 0.148438 51.5766 0.148438 114.997C0.148438 178.417 51.606 229.829 115.082 229.829Z",
    fill: "#D6E6F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.715 49.0179L203.757 49.3234C206.474 49.3281 209.079 50.4122 210.997 52.3371C212.915 54.262 213.99 56.8701 213.985 59.5876L213.785 174.235C213.78 176.953 212.696 179.557 210.771 181.475C208.847 183.393 206.238 184.468 203.521 184.464L19.9185 184.143C19.4715 184.142 19.043 183.964 18.7275 183.647C18.4119 183.331 18.235 182.902 18.2358 182.455L18.4509 59.2463C18.4556 56.5288 19.5397 53.9245 21.4646 52.0063C23.3895 50.0881 25.9976 49.0131 28.715 49.0179Z",
    fill: "#637582"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.921 67.0503L211.752 173.571C211.749 175.452 211.375 177.314 210.652 179.05C209.929 180.787 208.87 182.364 207.538 183.691C206.205 185.018 204.623 186.07 202.884 186.786C201.144 187.502 199.281 187.868 197.4 187.863L101.836 187.718C133.141 150.959 147.914 84.9181 153.525 52.6621L197.629 52.7344C199.508 52.7343 201.368 53.1048 203.103 53.8246C204.839 54.5443 206.416 55.5992 207.743 56.9288C209.07 58.2585 210.123 59.8369 210.84 61.5736C211.556 63.3104 211.924 65.1714 211.921 67.0503Z",
    fill: "#455760"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7305 70.3462L23.8951 70.357L23.6977 183.476L17.533 183.465L17.7305 70.3462Z",
    fill: "#94A5AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.571 59.5979V71.289L15 70.9278V59.2607C15.0843 57.5475 15.8434 55.9374 17.1113 54.7822C18.3793 53.627 20.053 53.0208 21.7667 53.0961L203.852 53.4091C205.563 53.3439 207.229 53.9581 208.488 55.1177C209.747 56.2773 210.496 57.888 210.571 59.5979Z",
    fill: "#ECEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6384 63.5704C31.7222 63.5704 32.6009 62.6917 32.6009 61.6078C32.6009 60.5239 31.7222 59.6453 30.6384 59.6453C29.5545 59.6453 28.6758 60.5239 28.6758 61.6078C28.6758 62.6917 29.5545 63.5704 30.6384 63.5704Z",
    fill: "#272834"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6969 63.5829C39.7808 63.5829 40.6595 62.7042 40.6595 61.6203C40.6595 60.5364 39.7808 59.6577 38.6969 59.6577C37.613 59.6577 36.7344 60.5364 36.7344 61.6203C36.7344 62.7042 37.613 63.5829 38.6969 63.5829Z",
    fill: "#272834"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7477 63.5941C47.8316 63.5941 48.7103 62.7154 48.7103 61.6315C48.7103 60.5476 47.8316 59.6689 46.7477 59.6689C45.6638 59.6689 44.7852 60.5476 44.7852 61.6315C44.7852 62.7154 45.6638 63.5941 46.7477 63.5941Z",
    fill: "#272834"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.278 53.5286L122.755 71.3844L110.738 71.3724L121.249 53.5166L133.278 53.5286Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M161.399 53.5775L150.888 71.4333L138.836 71.4212L149.359 53.5654L161.399 53.5775Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M204.033 51.3834L22.9351 51.0673C18.9453 51.0603 15.7053 54.2891 15.6983 58.2789L15.4877 178.971C15.4807 182.961 18.7094 186.201 22.6992 186.208L203.797 186.524C207.787 186.531 211.027 183.302 211.034 179.312L211.245 58.6202C211.252 54.6304 208.023 51.3903 204.033 51.3834Z",
    stroke: "#272834",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6836 70.5063L212.254 70.8314",
    stroke: "#272834",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1719 86.8691L123.958 87.0136",
    stroke: "#FFC754",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1523 101.691L85.7109 101.775",
    stroke: "#A2FCE2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1289 116.513L94.6094 116.609",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.359 101.799L106.885 101.811",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.973 116.633L120.868 116.657",
    stroke: "#FFC754",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHustlersIcon);
export default __webpack_public_path__ + "static/media/hustlers-icon.29d28e093087f52fe4fccd37abe6141d.svg";
export { ForwardRef as ReactComponent };